import React, { useState, useContext } from 'react'
import { useLocation, useHistory, useParams } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import slugify from 'slugify'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import cookie from 'react-cookies'
import history from '../../../history'
import AppContext from '../../../context/appContext'

import Loader from '../../Loader/Loader'
import {
  ScreenContainer,
  MainHeader,
  MainContentContainer,
  MainSubHeader,
  VerticalDivider,
  MealIngredientName,
  MealIngredientKcalValue,
  MealIngredientWeightValue,
  MealIngredientRow,
  MealsMainHeader,
  DietStandardButton,
  DietStandardRow,
  NoMeals,
} from '../Shared/SharedStyledComponents'
import { TopColorBar } from '../../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import BackButton from '../../shared/BackButton'
import NavigationBar from '../../NavigationBar/NavigationBar'
import {
  MealsList,
  MealContainer,
  MealNutritionalValue,
} from './MealsScreenStyles'
import DemoModeAnnouncement from '../../DemoModeAnnouncement/DemoModeAnnouncement.jsx'

import { MealsContainer } from '../style/DietStyle'

import AddMealicon from '../../../assets/REDESIGN_Assets/Diet/add-meal-icon.svg'
import ProductIcon from '../../../assets/REDESIGN_Assets/Diet/product-icon.svg'

import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericMobileTopNavigation from '../../../GenericComponents/GenericMobileTopNavigation'
import Navigation from "../../Challenges/components/Navigation/Navigation"
interface MealsScreenProps {
  chosedMealType: string
  meals: any
  sniadanie: any
  IIsniadanie: any
  obiad: any
  przekaska: any
  kolacja: any
  todayDate: any
  chosenDate: any
  mealTypefromUrl: any
  mealTypeFilters: any
  kcalFilters: any
  diet: any
  changeDiet: any
  isDemoAccount: boolean
  challengeMode: boolean
}

const MealsScreen: React.FC<MealsScreenProps> = ({
  chosedMealType,
  meals,
  todayDate,
  chosenDate,
  mealTypefromUrl,
  mealTypeFilters,
  kcalFilters,
  diet,
  changeDiet,
  // isDemoAccount,
  challengeMode
}) => {
  let history = useHistory()
  const location = useLocation()
  const { promiseInProgress } = usePromiseTracker()
  const appContext = useContext(AppContext)

  const goBackToDietMainPage = () => {
    history.push('/dieta')
  }

  const goToMealDetails = (
    chosedMeal: string,
    mealId: number,
    todayDate: any,
    chosenDate: any
  ) => {
    history.push({
      pathname: `/dieta/szczegoly-posilku/${chosenDate ? chosenDate : todayDate
        }/${mealId}/${slugify(chosedMeal)}`,
      state: {
        chosedMeal: chosedMeal,
        chosedMealType: chosedMealType ? chosedMealType : mealTypefromUrl,
        todayDate: todayDate,
        chosenDate: chosenDate,
        challengeMode: challengeMode
      },
    })
  }

  const goToFilterScreen = () => {
    history.push({
      pathname: `/dieta/${chosenDate ? chosenDate : todayDate}/filtruj-posilki`,
      chosedMealType: chosedMealType ? chosedMealType : mealTypefromUrl,
      mealTypeFilters: mealTypeFilters,
      kcalFilters: kcalFilters,
    })
  }

  const colorHoveredElement = (e: any) => {
    e.target.classList.add('active')
  }

  const unColorHoveredElement = (e: any) => {
    e.target.classList.remove('active')
  }

  const checkIfMealHasCorrectFilter = (mealType: any, mealKcal: any) => {
    let isFilterCorrect = false

    if (
      mealTypeFilters === null &&
      kcalFilters === null &&
      !cookie.load('userResettedFiltersOnMainPage')
    ) {
      if (mealTypeFilters === null && kcalFilters === null) {
        isFilterCorrect = true
        return isFilterCorrect
      }
    } else {
      if (
        mealTypeFilters &&
        mealTypeFilters.length != 0 &&
        kcalFilters != undefined &&
        Object.keys(kcalFilters).length != 0
      ) {
        mealTypeFilters.forEach((mealFilter: any) => {
          if (
            mealFilter.value == mealType &&
            mealKcal >= kcalFilters.valMin &&
            mealKcal <= kcalFilters.valMax
          ) {
            isFilterCorrect = true
            return isFilterCorrect
          }
        })
      } else if (
        mealTypeFilters &&
        mealTypeFilters.length != 0 &&
        (kcalFilters == undefined || Object.keys(kcalFilters).length === 0)
      ) {
        mealTypeFilters.forEach((mealFilter: any) => {
          if (mealFilter.value == mealType) {
            isFilterCorrect = true
            return isFilterCorrect
          }
        })
      } else if (
        mealTypeFilters &&
        mealTypeFilters.length == 0 &&
        kcalFilters != undefined
      ) {
        isFilterCorrect =
          mealKcal >= kcalFilters.valMin && mealKcal <= kcalFilters.valMax
      } else {
        isFilterCorrect = mealTypefromUrl == mealType
      }
    }
    return isFilterCorrect
  }

  return (
    <GenericBackgroundLayer
      className={`${appContext.appState.theme == 'light' ? 'light' : 'standard'
        }`}
      fDir={'column'}
      justify="flex-start"
    >
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          handleClick={() => challengeMode ? history.push({ pathname: '/dieta', state: { challengeMode: challengeMode } }) : history.push('/dieta')}
          dietCartClick={() =>
            history.push({
              pathname: `/dieta/${chosenDate ? chosenDate : todayDate
                }/lista-zakupow/`,
              state: { chosenDate: chosenDate, challengeMode: challengeMode },
            })
          }
        />
      )}
      {/* <TopColorBar relative>
        <BackButton place={'Gotowe posiłki'} specialLocation={'/dieta'} />
      </TopColorBar> */}
      {challengeMode ? <Navigation /> : <NavigationBar
        isPlayerView={false}
        backButtonAction={goBackToDietMainPage}
      />}

      <GenericMainCard
        flexDir={'column'}
        className="standard"
        width={isMobile ? '95%' : '50%'}
        margin={isMobile ? '0 auto' : '5% auto 0 auto'}
      >
        <GenericRow width={'100%'}>
          <GenericTextSpan fSize={'1.6rem'} margin={'0 0 5% 0'}>
            {diet && diet.diet_name}
          </GenericTextSpan>
        </GenericRow>

        <MealsContainer>
          <GenericRow width={'100%'}>
            <GenericTextSpan
              fSize={isMobile ? '1.2rem' : '1.6rem'}
              margin={'0 0 5% 0'}
            >
              Gotowe posiłki
            </GenericTextSpan>
          </GenericRow>

          {meals
            ? meals.map((meal: any, i: any) =>
              checkIfMealHasCorrectFilter(
                meal.meal_type,
                meal.calories.amount
              ) ? (
                <MealContainer
                  className="meal-container"
                  onMouseEnter={(e: any) => colorHoveredElement(e)}
                  onMouseLeave={(e: any) => unColorHoveredElement(e)}
                  onClick={() =>
                    goToMealDetails(meal.name, meal.id, todayDate, chosenDate)
                  }
                >
                  <MealIngredientRow justify="space-between">
                    <GenericRow
                      justify={'flex-start'}
                      className="main-row"
                      width={isMobile ? '95%' : '80%'}
                      align={'baseline'}
                    >
                      {/* <GenericIcon
                          src={ProductIcon}
                          width={isMobile ? '3vw' : '0.8vw'}
                          height={isMobile ? '3vw' : '0.8vw'}
                          margin={'0 2% 0 0'}
                        /> */}
                      <MealIngredientName color={'#212121'}>
                        {meal.name}
                      </MealIngredientName>
                    </GenericRow>
                    <GenericRow
                      justify={'space-between'}
                      width={'20%'}
                      margin={'0 10% 0 0'}
                    >
                      <MealIngredientKcalValue color={'#212121'}>
                        {meal.calories.amount} kcal
                      </MealIngredientKcalValue>
                      <GenericIcon
                        position="absolute"
                        right={'-60%'}
                        src={AddMealicon}
                        width={isMobile ? '4.5vw' : '1vw'}
                        height={isMobile ? '4.5vw' : '1vw'}
                      />
                    </GenericRow>
                  </MealIngredientRow>
                  <MealIngredientRow
                    margin={isMobile ? '4px 0' : '5px 0'}
                    justify="space-between"
                    width={isMobile ? '35%' : '40%'}
                  >
                    <MealNutritionalValue>
                      B: {meal.calories.protein}g
                    </MealNutritionalValue>
                    <MealNutritionalValue>
                      W: {meal.calories.carbs}g
                    </MealNutritionalValue>
                    <MealNutritionalValue>
                      T: {meal.calories.fat}g
                    </MealNutritionalValue>
                  </MealIngredientRow>
                </MealContainer>
              ) : null
            )
            : null}
        </MealsContainer>
        {promiseInProgress && <Loader />}
      </GenericMainCard>
      {/* <MainHeader>Diety</MainHeader>
      <MainSubHeader>{diet && diet.diet_name}</MainSubHeader> */}
      {/* <DietStandardButton
        margin={'10px auto'}
        color={'white'}
        backgroundColor="blueviolet"
        onClick={changeDiet}
      >
        Zmień dietę
      </DietStandardButton> */}
      {/* <MainContentContainer
        padding={isMobile ? '2vh 1vw' : '5vh 3vw'}
        marginTop={isMobile ? '1vh' : '5vh'}
        justify={'center'}
        flexDirection={isMobile ? 'column' : 'unset'}
      > */}
      {/* <MealsMainHeader>GOTOWE POSIŁKI</MealsMainHeader>
        <MealsList>
          {meals
            ? meals.map((meal: any, i: any) =>
                checkIfMealHasCorrectFilter(
                  meal.meal_type,
                  meal.calories.amount
                ) ? (
                  <MealContainer
                    onMouseEnter={(e: any) => colorHoveredElement(e)}
                    onMouseLeave={(e: any) => unColorHoveredElement(e)}
                    onClick={() =>
                      goToMealDetails(meal.name, meal.id, todayDate, chosenDate)
                    }
                  >
                    <MealIngredientRow justify="space-between">
                      <MealIngredientName color={'#212121'}>
                        {meal.name}
                      </MealIngredientName>
                      <MealIngredientKcalValue color={'#212121'}>
                        {meal.calories.amount} kcal
                      </MealIngredientKcalValue>
                    </MealIngredientRow>
                    <MealIngredientRow
                      margin="5px 0"
                      justify="space-between"
                      width={isMobile ? '30%' : '50%'}
                    >
                      <MealNutritionalValue>
                        B - {meal.calories.protein}
                      </MealNutritionalValue>
                      <MealNutritionalValue>
                        W - {meal.calories.carbs}
                      </MealNutritionalValue>
                      <MealNutritionalValue>
                        T - {meal.calories.fat}
                      </MealNutritionalValue>
                    </MealIngredientRow>
                  </MealContainer>
                ) : null
              )
            : null}
        </MealsList>
        <DietStandardRow justify="center" marginTop="50px">
          <DietStandardButton
            padding="10px 40px"
            backgroundColor="#fe0d9f"
            onClick={goToFilterScreen}
            color={'white'}
          >
            filtruj
          </DietStandardButton>
        </DietStandardRow>
        {isDemoAccount && <DemoModeAnnouncement />}
      </MainContentContainer>
      {promiseInProgress && <Loader />} */}
    </GenericBackgroundLayer>
  )
}

export default MealsScreen
